import React from "react";
import { Box, Button, IconButton, SxProps, Typography } from "@mui/material";
import { useField, useFormikContext, ErrorMessage } from "formik";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CancelIcon from "@mui/icons-material/Cancel";
import { CustomTooltip } from "../tooltip/CustomToolTip";

type Props = {
  fieldName: string;
  label: string;
  acceptFormats: string;
  isMandatory: boolean;
  sx?: SxProps;
};

const FormikFileInput = ({
  fieldName,
  label,
  acceptFormats,
  isMandatory,
  sx,
}: Props) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [field] = useField(fieldName);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    setFieldTouched(fieldName, true);
    const file = event.target.files[0];
    setFieldValue(fieldName, file);
    event.target.value = "";
  };

  const handleRemoveFile = () => {
    setFieldValue(fieldName, null);
  };

  return (
    <Box>
      <Button
        sx={sx}
        component="label"
        variant="contained"
        startIcon={<CloudUploadIcon />}
      >
        Upload {label}
        <input
          type="file"
          id={fieldName}
          name={fieldName}
          accept={acceptFormats}
          onChange={handleFileChange}
          hidden
        />
      </Button>
      {isMandatory && (
        <Typography
          ml={-1}
          variant="h5"
          color={"primary.main"}
          display={"inline"}
        >
          <b>*</b>
        </Typography>
      )}
      <Typography color="error" mt={-1} ml={1}>
        <ErrorMessage name={fieldName} />
      </Typography>
      {field.value && (
        <Box display="flex" mt={-2} mb={-1} ml={1} alignItems="center">
          <Typography variant="body2" color="textSecondary">
            {field.value.name}
          </Typography>
          <CustomTooltip arrow title="Remove File">
            <IconButton type="button" onClick={handleRemoveFile}>
              <CancelIcon
                sx={{
                  display: "inline",
                  cursor: "pointer",
                  color: "primary.main",
                }}
              />
            </IconButton>
          </CustomTooltip>
        </Box>
      )}
    </Box>
  );
};

export default FormikFileInput;
